<template>
  <div id="ExamsMain">

    <keep-alive> <router-view></router-view></keep-alive>

  </div>
</template>

<script>
  export default {
    data () {
      return  {

      }
    },
    methods: {
       back() {
      this.$router.push('/dashboard');
    },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Exams/ExamsMain.vue